export function Notes() {
  return (
    <section className="section">
      <h2 className="section-title">Worth knowing</h2>

      <ul className="notes">
        <li>
          <b>Capitalisation matters.</b> <code>ANIIMOGIFT</code> is uppercase,{' '}
          <code>Aniimo2026</code> is capitalised, the rest are lowercase. Paste rather than type.
        </li>
        <li>
          <b>Codes run out as well as expire.</b> <code>aniimoparty</code> hit its redemption cap a
          day after it appeared, so redeem early.
        </li>
        <li>
          <b>One go per account.</b> A second attempt gives the same message as a dead code, which
          is worth checking before reporting one as broken.
        </li>
        <li>
          <b>Squad codes are different.</b> The six-character codes from the Aniimo Together event
          are player invites and will not work in the redemption box.
        </li>
      </ul>
    </section>
  );
}
